import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductStore } from '@b2b/features/product/core/utilities/product.model';

export const PRODUCT_FEATURE = 'PRODUCT';

export const selectProduct = createSelector(
  createFeatureSelector<ProductStore>(PRODUCT_FEATURE),
  state => state.product,
);

export const selectProductPrice = createSelector(
  createFeatureSelector<ProductStore>(PRODUCT_FEATURE),
  state => state.price,
);

export const selectProductStock = createSelector(
  createFeatureSelector<ProductStore>(PRODUCT_FEATURE),
  state => state.stock,
);
